











































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class SkalaNyeriNew extends Vue {
  @Prop() skala!: number;
  @Prop() radioNyeri!: boolean;
  @Prop() infoNyeri!: boolean;
  @Prop() nyeri!: any;

  colSkala = "";
  warna = "green";
  textSkala = "Tidak Nyeri";
  rangeSkala = ["0", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  metode = "nrs";
  nips = [
    {
      id: "face",
      title: "Ekspresi Wajah",
      val: null
    },
    {
      id: "cry",
      title: "Menangis",
      val: null
    },
    {
      id: "breath",
      title: "Pola pernapasan",
      val: null
    },
    {
      id: "arms",
      title: "Tangan",
      val: null
    },
    {
      id: "legs",
      title: "Kaki",
      val: null
    },
    {
      id: "arousal",
      title: "Tingkat kesadaran",
      val: null
    }
  ];
  nipsOption = {
    face: [
      {
        id: 0,
        name: "Otot-oto relaks",
        text: "Wajah tenang, ekspresi netral"
      },
      {
        id: 1,
        name: "Meringis",
        text: "Otot wajah tegang, alis mengkerut, dagu dan rahang tegang"
      }
    ],
    cry: [
      {
        id: 0,
        name: "Tidak menangis",
        text: ""
      },
      {
        id: 1,
        name: "Mengerang",
        text: "Merengek ringan, kadang2 menangis"
      },
      {
        id: 2,
        name: "Menangis keras",
        text: "Berteriak kencang, menangis melengking terus menerus"
      }
    ],
    breath: [
      {
        id: 0,
        name: "Bernapas rileks",
        text: "pola pernapasan normal"
      },
      {
        id: 1,
        name: "Perubahan pola pernapasan",
        text:
          "tidak teratur, lebih cepat dari biasanya, tersedak, napas tertahan"
      }
    ],
    arms: [
      {
        id: 0,
        name: "Rileks",
        text:
          "tidak ada kekakuan otot, gerakan otot sesekali tegang, lengan lurus"
      },
      {
        id: 1,
        name: "Fleksi/Ekstensi",
        text: "Kaku: fleksi/ekstensi"
      }
    ],
    legs: [
      {
        id: 0,
        name: "Rileks",
        text:
          "tidak ada kekakuan otot, gerakan otot sesekali tegang, kaki lurus"
      },
      {
        id: 1,
        name: "Fleksi/Ekstensi",
        text: "Kaku: fleksi/ekstensi"
      }
    ],
    arousal: [
      {
        id: 0,
        name: "Tidur/terjaga",
        text: "tenang, tidur damai"
      },
      {
        id: 1,
        name: "Rewel",
        text: "Terjaga, gelisah, meronta"
      }
    ]
  };

  flacc = [
    {
      id: "face",
      title: "Wajah",
      val: null
    },
    {
      id: "legs",
      title: "Kaki",
      val: null
    },
    {
      id: "activity",
      title: "Aktivitas",
      val: null
    },
    {
      id: "cry",
      title: "Menangis",
      val: null
    },
    {
      id: "consolability",
      title: "Konsolabilitas",
      val: null
    }
  ];
  flaccOption = {
    face: [
      {
        id: 0,
        name: "Tidak ada ekspresi khusus, senyum",
        text: ""
      },
      {
        id: 1,
        name: "Terkadang meringis/menarik diri",
        text: ""
      },
      {
        id: 2,
        name: "Sering menggertakan dagu dan mengatupkan rahang",
        text: ""
      }
    ],
    legs: [
      {
        id: 0,
        name: "Normal, rileks",
        text: ""
      },
      {
        id: 1,
        name: "Gelisah, tegang",
        text: ""
      },
      {
        id: 2,
        name: "Menendang, kaki tertekuk, melengkungkan punggung",
        text: ""
      }
    ],
    activity: [
      {
        id: 0,
        name: "Berbaring tenang, posisi normal, mudah bergerak",
        text: ""
      },
      {
        id: 1,
        name: "Menggeliat, tidak bisa diam, kaku mengerang",
        text: ""
      },
      {
        id: 2,
        name: "Kaku atau menghentak",
        text: ""
      }
    ],
    cry: [
      {
        id: 0,
        name: "Tidak menangis",
        text: ""
      },
      {
        id: 1,
        name: "Merintih, merengek, kadang-kadang mengeluh",
        text: ""
      },
      {
        id: 2,
        name: "Terus menangis, berteriak, sering mengeluh",
        text: ""
      }
    ],
    consolability: [
      {
        id: 0,
        name: "Rileks",
        text: ""
      },
      {
        id: 1,
        name:
          "Dapat ditenangkan dengan sentuhan, pelukan, bujukan, dapat dialihkan",
        text: ""
      },
      {
        id: 2,
        name: "Sulit dibujuk",
        text: ""
      }
    ]
  };

  bps = [
    {
      id: "face",
      title: "Ekspresi Wajah",
      val: null
    },
    {
      id: "ekstremitas",
      title: "Pergerakan ekstremitas atas atau posisi",
      val: null
    },
    {
      id: "vent_tolerance",
      title: "Toleransi terhadap ventilasi mekanik ventilator",
      val: null
    }
  ];
  bpsOption = {
    face: [
      {
        id: 1,
        name: "Tenang",
        text: ""
      },
      {
        id: 2,
        name: "Sebagian wajah tegang",
        text: "(dahi mengkerut)"
      },
      {
        id: 3,
        name: "Seluruh wajah tegang",
        text: "(kelopak mata menutup)"
      },
      {
        id: 4,
        name: "Wajah menyeringai dan mengkerut",
        text: ""
      }
    ],
    ekstremitas: [
      {
        id: 1,
        name: "Tenang",
        text: ""
      },
      {
        id: 2,
        name: "Sebagian pada daerah siku menekuk",
        text: ""
      },
      {
        id: 3,
        name: "Menekuk total dengan jari mengepal",
        text: ""
      },
      {
        id: 4,
        name: "Menekuk total dengan terus-menerus",
        text: ""
      }
    ],
    vent_tolerance: [
      {
        id: 1,
        name: "Bisa mengikuti irama/pola ventilasi",
        text: ""
      },
      {
        id: 2,
        name:
          "Adanya respon batuk tetapi tetap masih dapat mengikuti pola ventilasi",
        text: ""
      },
      {
        id: 3,
        name: "Melawan pola ventilasi",
        text: ""
      },
      {
        id: 4,
        name: "Tidak mampu mentoleransi pola ventilasi",
        text: ""
      }
    ]
  };

  selectProps = { openOnHover: true, offsetY: true };

  get metodeInput() {
    if (this.metode == "nips") {
      return this.nips;
    }

    if (this.metode == "flacc") {
      return this.flacc;
    }

    if (this.metode == "bps") {
      return this.bps;
    }

    return [];
  }
  get metodeOption() {
    if (this.metode == "nips") {
      return this.nipsOption;
    }

    if (this.metode == "flacc") {
      return this.flaccOption;
    }

    if (this.metode == "bps") {
      return this.bpsOption;
    }

    return null;
  }

  get totalScore() {
    return this.metodeInput.map(i => i.val).reduce((a, b) => a + b, 0);
  }

  @Watch("skala")
  changeNyeri(val) {
    if (this.infoNyeri == true) {
      this.colSkala == "9";
    } else {
      this.colSkala = "12";
    }

    if (this.skala == 0) {
      this.warna = "green";
      this.textSkala = "Tidak Nyeri";
    } else if (this.skala < 4) {
      this.warna = "#FBC02D";
      this.textSkala = "Nyeri Ringan";
    } else if (this.skala < 7) {
      this.warna = "#F57C00";
      this.textSkala = "Nyeri Sedang";
    } else {
      this.warna = "#DD2C00";
      this.textSkala = "Nyeri Berat";
    }

    this.$emit("skalaNyeri", val);
  }

  @Watch("totalScore")
  changeTotalScore(val) {
    this.skala = val;
  }

  @Watch("metode")
  changeMetode(val, oldVal) {
    if (!oldVal) {
      this.$emit("setMetode", val);

      if (val !== oldVal) {
        this.skala = 0;
      }

      if (val == "nips") {
        this.$emit("setQuestion", this.nips);
      } else if (val == "flacc") {
        this.$emit("setQuestion", this.flacc);
      } else if (val == "bps") {
        this.$emit("setQuestion", this.bps);
      } else {
        for (let i = 0; i < this.nips.length; i++) {
          this.nips[i].val = null;
        }

        this.$emit("setQuestion", null);
      }
    }
  }

  @Watch("nyeri", { deep: true })
  changeQuestion(val) {
    console.log("change nyeri", val);
    // this.skala = val.skala;
    this.metode = val.metode;
    if (this.metode === "nips") {
      this.nips = val.question;
    }
  }
}
